module.exports = __webpack_public_path__ + "static/media/bicoBronze90.655dbe45.png";